import * as Icons from "lucide-react";
import { SERVIZI } from "@/config/site";

export const Servizi = () => (
  <section id="servizi" className="bg-ivory py-20 lg:py-28" data-testid="servizi-section">
    <div className="container-ph">
      <div className="reveal max-w-xl">
        <span className="gold-line mb-5" />
        <h2 className="h-section">Cosa facciamo</h2>
      </div>
      <div className="mt-12 grid gap-px bg-ivory-dark sm:grid-cols-2 lg:grid-cols-4 border border-ivory-dark">
        {SERVIZI.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Circle;
          return (
            <div key={s.title} className={`reveal reveal-delay-${(i % 4) % 3 + 1} bg-ivory p-7 lg:p-8 transition-colors duration-300 hover:bg-warm`} data-testid={`servizio-item-${i + 1}`}>
              <Icon size={28} strokeWidth={1.25} className="text-forest" />
              <h3 className="mt-6 text-xs font-bold tracking-[0.18em] text-forest">{s.title}</h3>
              <p className="mt-3 text-sm text-ink/75 leading-relaxed">{s.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
